<div class="roster-clone-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Clone Roster</h2>
    <button mat-icon-button (click)="onCancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content>
    <!-- Source Info -->
    <div class="info-row">
      <span class="info-item"><strong>Source Week:</strong> {{sourceWeekLabel}}</span>
    </div>

    <p class="description">Select a future target week and choose whether to clone scheduled rostered hours or actual clock times.</p>

    <form [formGroup]="form" class="clone-form">
      <!-- Target Selection Row -->
      <div class="row">
        <mat-form-field appearance="outline" class="year-field">
          <mat-label>Target Year</mat-label>
          <mat-select formControlName="target_year" cdkFocusInitial>
            <mat-option *ngFor="let y of years" [value]="y.year">{{y.display_year}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="week-field">
          <mat-label>Target Week No</mat-label>
          <mat-select formControlName="target_week">
            <mat-option *ngFor="let w of weeks" [value]="w.value">
              {{w.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Time Mode Selection -->
      <div class="mode-selection-container">
        <label class="section-label">Select Hours Type to Clone</label>
        <mat-radio-group formControlName="clone_type" class="clone-type-radio-group">
          <mat-radio-button value="rostered" class="clone-radio-button">
            <div class="radio-btn-content">
              <div class="main-txt">Rostered work hours</div>
              <div class="sub-txt">Clones the originally planned shift times</div>
            </div>
          </mat-radio-button>

          <mat-radio-button value="actual" class="clone-radio-button">
            <div class="radio-btn-content">
              <div class="main-txt">Actual Work hours</div>
              <div class="sub-txt">Clones the actual attendance clock-in & clock-out times</div>
            </div>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <div class="spacer"></div>
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onClone()" [disabled]="form.invalid">
      Clone Roster
    </button>
  </div>
</div>
